






import { Component, Vue } from "vue-property-decorator";
import ListDividedItem from "./ListDividedItem.vue";

@Component({
  components: {
    ListDividedItem,
  },
})
export default class ListDivided extends Vue {}
